export const HOME = '/';
export const FLOW = '/flow';
export const DAG = '/dag';
export const DAG_RUN = '/run';
